import {
  identity,
  HomeUser,
  appendAndRefreshTweekContext,
  initTweekRepo,
  UserBrowser,
} from '@soluto-home-web/platform-core';
import { userAgentParser } from '@soluto-home-web/platform-utils';

const tweekDefaults = require('../tweek-defaults.json');

function updateTweekContextForHomeUser(user: HomeUser, context) {
  if (user) {
    if (user.id) context.home_user['id'] = user.id;
    context.user_browser['IsIdentified'] = true;
    if (user.flowId) context.home_user['MessagingLinkFlow'] = user.flowId;
  }
}

export function initTweek() {
  const defaultTweekContext = {
    home_user: {
      Partner: globals.REACT_APP_PARTNER,
      IsTest: globals.REACT_APP_IS_TEST,
      FormFactor: userAgentParser.getFormFactor()
    },
    user_browser: {
      id: UserBrowser.Id,
      Partner: globals.REACT_APP_PARTNER,
      IsTest: globals.REACT_APP_IS_TEST
    },
  };

  updateTweekContextForHomeUser(identity.get(), defaultTweekContext);
  initTweekRepo(defaultTweekContext, tweekDefaults);

  identity.updated$.subscribe(user => {
    const context = { home_user: {}, user_browser: {} };
    updateTweekContextForHomeUser(user, context);
    appendAndRefreshTweekContext(context);
  });
}



// WEBPACK FOOTER //
// ./packages/web-app/src/services/tweekInitializer.ts